import { Select } from "antd";
const { Option } = Select;

export default function SelectSin({
  onChange,
  placeholder,
  options,
  value,
  name,
}) {
  const handleChange = (val) => {
    onChange({ target: { name, value: val } });
  };

  return (
    <div>
      <Select
        value={value}
        style={{ width: 120 }}
        placeholder={placeholder}
        onChange={handleChange}
        style={{ width: "100%" }}
      >
        {options.map((o) => (
          <Option key={o.value} value={o.value}>
            {o.text}
          </Option>
        ))}
      </Select>
    </div>
  );
}
